module.exports = __webpack_public_path__ + "img/objects-box.302262f5.png";